import { render, staticRenderFns } from "./ElementsTablePreview.vue?vue&type=template&id=d2cdf0bc&"
import script from "./ElementsTablePreview.vue?vue&type=script&lang=js&"
export * from "./ElementsTablePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports